import React from 'react';
import { Link } from 'react-router-dom';
interface LegalProps {
  kind: 'privacy' | 'terms';
}
const copy = {
  privacy: {
    title: 'Privacy',
    body: 'Noetivra’s full privacy notice is being prepared alongside the production platform. Information submitted through our contact form is used only to respond to your inquiry. Interactive demonstrations use sample data and store any changes on your own device.'
  },
  terms: {
    title: 'Terms',
    body: 'Terms of use for Noetivra will be published with the production platform. The interactive demonstrations are provided for evaluation and use sample data only.'
  }
};
export function Legal({
  kind
}: LegalProps) {
  const {
    title,
    body
  } = copy[kind];
  return <section className="pb-32 pt-14 md:pt-20" data-id="element-721" data-mp="5354ilkos0hh">
      <div className="mx-auto max-w-2xl px-5 md:px-8" data-id="element-722" data-mp="3n88h0rczferx">
        <h1 className="text-4xl font-semibold tracking-display sm:text-5xl" data-id="element-723" data-mp="3n8qhy1alah66">{title}</h1>
        <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-724" data-mp="3s6067dm8smsf">{body}</p>
        <p className="mt-6 text-[15px] text-ink-soft" data-id="element-725" data-mp="27kd7gw1col7e">
          Questions?{' '}
          <Link to="/contact" className="font-medium text-accent hover:text-accent-ink" data-id="element-726" data-mp="23jt8dmx7v7im">
            Contact us
          </Link>
          .
        </p>
      </div>
    </section>;
}